import { AuthenticatedUser } from "@gettactic/api";

export const SEARCH_DEBOUNCE_MS = 300;
export const LIVE_MODE_UPDATE_INTERVAL_MS = 60000; // 1 minute
export const RESOURCE_INFO_MODAL_DELAY_MS = 800;
export const INPUT_FOCUS_DELAY_MS = 100;
export const TESSA_MESSAGE_DELAY_MS = 100;

export type Setting = {
  id: string;
  type: "action" | "setting";
  name: string;
  description?: string;
  url?: string;
  isAdmin?: boolean;
  isAvailable?: (authenticatedUser: AuthenticatedUser) => boolean;
};

export const QUICK_ACTIONS: Setting[] = [
  {
    id: "s-reserve-desk",
    type: "action",
    name: "Reserve desk",
    isAvailable: (authenticatedUser: AuthenticatedUser) =>
      authenticatedUser?.organization?.desk_bookings_enabled ?? false
  },
  {
    id: "s-reserve-room",
    type: "action",
    name: "Reserve meeting room",
    isAvailable: (authenticatedUser: AuthenticatedUser) =>
      authenticatedUser?.organization?.meeting_room_bookings_enabled ?? false
  }
];

export const SETTINGS: Setting[] = [
  {
    id: "s-profile-settings",
    type: "setting",
    url: "/settings/profile",
    name: "Profile Settings",
    description: "Manage your profile"
  },
  {
    id: "s-organization-settings",
    type: "setting",
    isAdmin: true,
    url: "/settings/organization",
    name: "Organization Settings",
    description: "General organization settings and defaults"
  },
  {
    id: "s-facilities",
    type: "setting",
    url: "/settings/offices",
    name: "Facilities",
    description:
      "Manage divisions, buildings, floors, zones, workspaces, and parking."
  },
  {
    id: "s-amenities",
    type: "setting",
    url: "/settings/amenities",
    name: "Amenities",
    description: "Create & edit amenities."
  },
  {
    id: "s-users-teams",
    type: "setting",
    isAdmin: true,
    url: "/settings/users",
    name: "Users & teams",
    description: "Manage all users and teams within your organization"
  },
  {
    id: "s-integrations",
    type: "setting",
    url: "/settings/integrations",
    name: "Integrations",
    description:
      "Set up integrations & third party apps with your Tactic account."
  }
];
